import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=1553196c&"
import script from "./product-detail.js?vue&type=script&lang=js&"
export * from "./product-detail.js?vue&type=script&lang=js&"
import style0 from "./product-detail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports